import { FormikProps } from 'formik';
import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { FormikFieldString } from 'Components/FormikComponents';
import { callAll } from 'Utils';
import EndDateTimePicker from 'Routes/ListManagement/components/EndDateTimePicker';
import StartDateTimePicker from 'Routes/ListManagement/components/StartDateTimePicker';
import { MERCHANT_OPTIONS } from 'Common/enums';
import { MerchantField, Comment } from './FormFields';

import styles from './styles.css';

type Props = {
    merchantSpecific: boolean;
    error: any;
    formikProps: FormikProps<any>;
};
function GeneralForm({ merchantSpecific, error, formikProps }: Props) {
    const { t } = useTranslation();
    const label = t('Value');
    let errorMsg = '';
    if (error?.data?.error?.message && formikProps.values.merchantOption[0] === MERCHANT_OPTIONS.SINGLE_MERCHANT) {
        errorMsg = t('addListEntry.uniqueSingleMerchEntry', { field: label });
    } else if (error?.data?.error?.message && formikProps.values.merchantOption[0] === MERCHANT_OPTIONS.ALL_MERCHANTS) {
        errorMsg = t('addListEntry.uniqueAllMerchEntry', { field: label });
    }

    return (
        <>
            {merchantSpecific && <MerchantField formikProps={formikProps} error={error} />}
            <div className={clsx(styles.formBlock, styles.shortInput)}>
                <FormikFieldString
                    label={label}
                    name='value'
                    handleChange={callAll(formikProps.handleChange)}
                    handleBlur={formikProps.handleBlur}
                    error={
                        !!(formikProps.errors.value && formikProps.touched.value) ||
                        error?.data?.error?.param === 'value'
                    }
                    errorMsg={(formikProps.errors.value as string) ?? errorMsg}
                    optionalMsg={t('validation.unique', { field: label })}
                />
            </div>
            <StartDateTimePicker formikProps={formikProps} />
            <EndDateTimePicker formikProps={formikProps} />

            <Comment formikProps={formikProps} error={error} />
        </>
    );
}

export default GeneralForm;
